import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('div', { 'className': 'SpecialVideoOverview' }, React.createElement('div', {
        'className': 'description formatted',
        'dangerouslySetInnerHTML': { __html: this.props.body }
    }));
}